import { render, staticRenderFns } from "./addHsfo.vue?vue&type=template&id=925d2b44"
import script from "./addHsfo.vue?vue&type=script&lang=js"
export * from "./addHsfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports